import { gql } from 'apollo-boost';

// input FindUsersInput {
// 	text: String!
// }

export const FIND_USERS = gql`
    query ($data: FindUsersInput!) {
        findUsers(data: $data) {
            users {
                id
                email
                fullName
                isVerified
                isLocked
                role
                createdAt
                deletedAt
                discoverySource
                discoverySourceOther
                deletionReasons
                deletionAdditionalFeedback
                planType
                quota {
                    maxMessages
                    totalMessages
                    maxStorage
                    totalStorage
                    maxFileSize
                    maxCredits
                    credits
                }
                profilePictureUrl
                isSubscribedToNewsletter
                referralId
                referralCount
                analytics {
                    homeFolderCount
                    subfolderCount
                    trashedFolderCount
                    totalInboxMessages
                    totalInboxTrashedMessages
                    totalTrashedMessages
                }
                settings {
                    usedMacApp
                    usedWindowsApp
                    usedAndroidApp
                    usedLinuxApp
                    usedIosApp
                    usedDesktopWebApp
                    usedClipper
                }
                adminAccess {
                    signInMethods {
                        provider
                        linkedAt
                        lastUsedAt
                        isPrivateRelayEmail
                    }
                    devices {
                        id
                        platform
                        appVersion
                        osVersion
                        deviceModel
                        timezone
                        notificationsEnabled
                        notificationPermissionStatus
                        lastSeenAt
                    }
                }
                usage {
                    lastLogin
                    lastActive
                    lastActiveDesktop
                    lastActiveMobile
                    lastFolderCreation
                    lastFolderUpdate
                    lastFolderMove
                    lastMessageCreation
                    lastMessageUpdate
                    lastMessageMove
                    totalLoginsDesktop
                    totalLoginsMobile
                    totalFolderViews
                    totalStarViews
                    totalTaskViews
                    totalMessageViews
                    totalSearchViews
                    totalFilterViews
                    totalInboxCreatedMessages
                    totalInboxMobileCreatedMessages
                    totalImageMessages
                    totalFileMessages
                    totalUrlMessages
                    totalNoteMessages
                    totalTaskMessages
                    totalStarMessages
                    totalExtensionCreatedMessages
                    totalMobileExtensionCreatedMessages
                    totalPermanentlyDeletedMessages
                    totalAiCalls
                    totalAiPromptTokens
                    totalAiCompletionTokens
                    totalAiTokens
                    totalCreditsSpent
                    totalAiEstimatedCostUsd
                    lastAiUsageAt
                }
            }
            cursor
        }
    }
`;
